<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo.end"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo.start"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :options="form.usuarios"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :options="form.receitaTipos"
                            @change="handleReceitaTipoChange"
                            default-option-text="Todos"
                            label="Tipo de receita"
                            show-default-option
                            text-field="nome"
                            v-model="model.receitaTipoId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :options="form.grupos"
                            @change="handleGrupoChange"
                            default-option-text="Todos"
                            label="Grupo"
                            show-default-option
                            text-field="nome"
                            v-model="model.grupoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :options="form.subgrupos"
                            @change="handleSubgrupoChange"
                            default-option-text="Todos"
                            label="Subgrupo"
                            show-default-option
                            text-field="nome"
                            v-model="model.subgrupoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :repository="repositories.relatorioDispensacaoPaciente.material"
                            :request-query-string-params="requestQueryStringParamsMaterial"
                            :search-fields="[{ key: 'cadastro_material.descricao', searchable: true }]"
                            @select="handleMedicamentoChange"
                            label="Medicamento"
                            text-field="descricao"
                            v-model="model.material"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :repository="repositories.relatorioDispensacaoPaciente.paciente"
                            :request-query-string-params="requestQueryStringParamsPaciente"
                            :search-fields="[{ key: 'cadastro_cidadao.nome', searchable: true }]"
                            @select="itens = []"
                            label="Paciente"
                            v-model="model.paciente"
                        />
                    </rkm-col>

                    <rkm-col
                        class="text-nowrap"
                        cols="auto"
                    >
                        <rkm-button
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :label="false"
                            @click="handleBuscarClick"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :label="false"
                            @click="handleLimparClick"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="itens.length > 0"
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="handleTodosClick"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedColumns"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    @click="handleImprimirClick"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fieldsPai"
                :items="itens"
                :per-page="10"
                :current-page="paginaAtual"
                @update:current-page="paginaAtual = $event"
                class="table-resultado"
            >
                <template v-slot:cell(pacienteInfo)="{ item }">
                    <div class="table-resultado-header-footer">
                        <rkm-row>
                            <rkm-col>
                                <strong>Paciente:</strong> {{ item.pacienteNome }}
                            </rkm-col>

                            <rkm-col cols="auto">
                                <strong>Prontuário:</strong> {{ item.pacienteProntuario }}
                            </rkm-col>

                            <rkm-col cols="auto">
                                <strong>Data de nascimento:</strong> {{ item.pacienteDataNascimento }}
                            </rkm-col>

                            <rkm-col cols="auto">
                                <strong>CNS:</strong> {{ item.pacienteCns }}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <strong>Endereço:</strong> {{ item.pacienteEndereco }}
                            </rkm-col>
                        </rkm-row>

                        <rkm-table
                            :fields="fields"
                            :items="item.entregas"
                            class="mt-3"
                            hide-pagination
                            hide-filters
                        >
                            <template v-slot:cell(quantidade)="{ item }">
                                <div v-for="(lote, i) in item.lotes" :key="i">
                                    {{ lote.quantidade }}
                                </div>
                            </template>

                            <template v-slot:cell(lote)="{ item }">
                                <div v-for="(lote, i) in item.lotes" :key="i">
                                    {{ lote.lote }}
                                </div>
                            </template>

                            <template v-slot:cell(dataValidade)="{ item }">
                                <div v-for="(lote, i) in item.lotes" :key="i">
                                    {{ lote.dataValidade }}
                                </div>
                            </template>

                            <template v-slot:cell(valorUnitario)="{ item }">
                                <div v-for="(lote, i) in item.lotes" :key="i">
                                    {{ lote.valorUnitario }}
                                </div>
                            </template>
                        </rkm-table>

                        <div class="table-resultado-header-footer text-center mt-2">
                            <span><strong>Total de atendimentos:</strong> {{ item.atendimentos }}</span>
                            <span class="ml-4"><strong>Total de medicamentos:</strong> {{ item.medicamentos }}</span>
                            <span class="ml-4"><strong>Valor total:</strong> {{ item.valorTotal }}</span>
                        </div>
                    </div>
                </template>
            </rkm-table>

            <div class="mt-3 footer-totalizadores d-flex justify-content-around">
                <span><strong>Total de pacientes:</strong> {{ getSafely(() => totalizadores.pacientes, 0) }}</span>
                <span><strong>Total de atendimentos:</strong> {{ getSafely(() => totalizadores.atendimentos, 0) }}</span>
                <span><strong>Total de medicamentos:</strong> {{ getSafely(() => totalizadores.medicamentos, 0) }}</span>
                <span><strong>Valor total:</strong> {{ getSafely(() => totalizadores.valorTotal, 0) }}</span>
            </div>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import { error, object, repository, stringCase, formats } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {
            return this.columns.filter(column => (column.fixed || false) || this.selectedColumns.includes(column.key))
        },
        optionalColumns() {
            return this.columns.filter(column => !(column.fixed || false))
        },
        validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        },
        requestQueryStringParamsMaterial() {
            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                receitaTipoId: this.model.receitaTipoId,
                grupoId: this.model.grupoId,
                subgrupoId: this.model.subgrupoId,
            }

            return this.camelObjectKeysToSnakeRecursive(request)
        },
        requestQueryStringParamsPaciente() {
            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                receitaTipoId: this.model.receitaTipoId,
                grupoId: this.model.grupoId,
                subgrupoId: this.model.subgrupoId,
                materialId: this.model.material ? this.model.material.id : null,
            }

            return this.camelObjectKeysToSnakeRecursive(request)
        },
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.farmacia'),
            relatorioDispensacaoPaciente: this.getConectaSusRepository('farmacia.relatorioDispensacaoPaciente'),
        }
    },
    data() {
        return {
            paginaAtual: 1,
            additionals: null,
            columns: [
                {
                    key: 'dataDispensacao',
                    label: 'Data de dispensação',
                    class: 'col-min text-center',
                    fixed: true,
                    sortable: true,
                    formatter: value => this.formatDate(value),
                    filterByFormatted: true,
                },
                {
                    key: 'dataHoraRegistro',
                    label: 'Data/Hora de registro',
                    class: 'col-min text-center',
                    sortable: true,
                    formatter: value => this.formatDateTime(value),
                    filterByFormatted: true,
                },
                { key: 'profissionalDispensadorNome', label: 'Profissional dispensador', sortable: true },
                { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true },
                { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                { key: 'profissionalPrescritorNome', label: 'Profissional prescritor', sortable: true },
                { key: 'materialDescricao', label: 'Medicamento', fixed: true, sortable: true },
                { key: 'quantidade', label: 'Quantidade', class: 'col-min text-center', fixed: true, sortable: true },
                { key: 'lote', label: 'Lote', class: 'col-min text-center', sortable: true },
                { key: 'dataValidade', label: 'Data de validade', class: 'col-min text-center', sortable: true },
                { key: 'valorUnitario', label: 'Valor unitário', class: 'col-min text-center', sortable: true },
            ],
            fieldsPai: [{ key: 'pacienteInfo', label: 'Informações dos Pacientes' }],
            form: null,
            indeterminate: false,
            itens: [],
            model: null,
            others: { moment },
            selectedAll: false,
            selectedColumns: [],
            totalizadores: null,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioDispensacaoPaciente.create()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.usuarios = []
            this.form.receitaTipos = []
            this.form.grupos = []
            this.form.subgrupos = []
            this.model.infraestruturaId = null
            this.model.usuarioId = null
            this.model.receitaTipoId = null
            this.model.grupoId = null
            this.model.subgrupoId = null
            this.model.material = null
            this.model.paciente = null
            this.itens = []

            this.setLoading()

            const request = {
                listar: 'infraestruturas',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: value,
            }

            this.repositories.relatorioDispensacaoPaciente.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.receitaTipos = Object.assign(response.data.receitaTipos)
                    this.form.grupos = Object.assign(response.data.grupos)
                    this.form.subgrupos = Object.assign(response.data.subgrupos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.usuarios = []
            this.form.receitaTipos = []
            this.form.grupos = []
            this.form.subgrupos = []
            this.model.usuarioId = null
            this.model.receitaTipoId = null
            this.model.grupoId = null
            this.model.subgrupoId = null
            this.model.material = null
            this.model.paciente = null
            this.itens = []

            this.setLoading()

            const request = {
                listar: 'usuarios',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.repositories.relatorioDispensacaoPaciente.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.receitaTipos = Object.assign(response.data.receitaTipos)
                    this.form.grupos = Object.assign(response.data.grupos)
                    this.form.subgrupos = Object.assign(response.data.subgrupos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange(value) {
            this.form.receitaTipos = []
            this.form.grupos = []
            this.form.subgrupos = []
            this.model.receitaTipoId = null
            this.model.grupoId = null
            this.model.subgrupoId = null
            this.model.material = null
            this.model.paciente = null
            this.itens = []

            this.setLoading()

            const request = {
                listar: 'receita-tipos',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: value,
            }

            this.repositories.relatorioDispensacaoPaciente.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.receitaTipos = Object.assign(response.data.receitaTipos)
                    this.form.grupos = Object.assign(response.data.grupos)
                    this.form.subgrupos = Object.assign(response.data.subgrupos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleReceitaTipoChange(value) {
            this.form.grupos = []
            this.form.subgrupos = []
            this.model.grupoId = null
            this.model.subgrupoId = null
            this.model.material = null
            this.model.paciente = null
            this.itens = []

            this.setLoading()

            const request = {
                listar: 'grupos',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                receitaTipoId: value,
            }

            this.repositories.relatorioDispensacaoPaciente.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.grupos = Object.assign(response.data.grupos)
                    this.form.subgrupos = Object.assign(response.data.subgrupos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleGrupoChange(value) {
            this.form.subgrupos = []
            this.model.subgrupoId = null
            this.model.material = null
            this.model.paciente = null
            this.itens = []

            this.setLoading()

            const request = {
                listar: 'subgrupos',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                receitaTipoId: this.model.receitaTipoId,
                grupoId: value,
            }

            this.repositories.relatorioDispensacaoPaciente.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.subgrupos = Object.assign(response.data.subgrupos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleSubgrupoChange() {
            this.model.material = null
            this.model.paciente = null
            this.itens = []
        },
        handleMedicamentoChange() {
            this.model.paciente = null
            this.itens = []
        },
        handleBuscarClick() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                receitaTipoId: this.model.receitaTipoId,
                grupoId: this.model.grupoId,
                subgrupoId: this.model.subgrupoId,
                materialId: this.model.material ? this.model.material.id : null,
                pacienteId: this.model.paciente ? this.model.paciente.id : null,
            }

            this.repositories.relatorioDispensacaoPaciente.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.itens = Object.assign(response.data.pacientes)
                    this.totalizadores = response.data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleLimparClick() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.usuarios = []
            this.form.receitaTipos = []
            this.form.grupos = []
            this.form.subgrupos = []
            this.model.periodo = {
                start: null,
                end: null,
            }
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.usuarioId = null
            this.model.receitaTipoId = null
            this.model.grupoId = null
            this.model.subgrupoId = null
            this.model.material = null
            this.model.paciente = null
            this.itens = []
        },
        handleTodosClick(selected) {
            this.selectedColumns = selected ? this.optionalColumns.map(c => c.key) : []
        },
        handleImprimirClick() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                receitaTipoId: this.model.receitaTipoId,
                grupoId: this.model.grupoId,
                subgrupoId: this.model.subgrupoId,
                materialId: this.model.material ? this.model.material.id : null,
                pacienteId: this.model.paciente ? this.model.paciente.id : null,
                selectedColumns: this.fields.map(field => ({
                    class: field.class,
                    key: this.camelToSnake(field.key),
                    label: field.label,
                })),
            }

            this.repositories.impressao.relatorioDispensacaoPaciente(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mounted() {
        this.load()
    },
    mixins: [ error, object, repository, stringCase, formats ],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                if (value.start && value.end) {
                    this.setLoading()

                    const request = {
                        listar: 'unidades',
                        periodo: {
                            start: this.others.moment(value.start).format('DD/MM/YYYY'),
                            end: this.others.moment(value.end).format('DD/MM/YYYY'),
                        },
                    }

                    this.repositories.relatorioDispensacaoPaciente.list(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.form.unidades = Object.assign(response.data.unidades)
                            this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                            this.form.usuarios = Object.assign(response.data.usuarios)
                            this.form.receitaTipos = Object.assign(response.data.receitaTipos)
                            this.form.grupos = Object.assign(response.data.grupos)
                            this.form.subgrupos = Object.assign(response.data.subgrupos)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            },
        },
        selectedColumns(value) {
            this.indeterminate = value.length > 0 && value.length != this.optionalColumns.length
            this.selectedAll = value.length > 0 && value.length == this.optionalColumns.length
        },
    },
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 300px;
}
.table-resultado >>> .table-resultado-header-footer, .footer-totalizadores {
    background: #f1f1f1;
    border: 1px solid #dee2e6;
    color: var(--gray-dark);
    font-weight: 600;
    padding: 0.5rem;
}
</style>